export default __webpack_public_path__ + "static/media/Mask Group 5.39d870c4.png";